export default "__VITE_ASSET__Ej0FSsri__"